<template>
    <div class="home-box">
        <v-progress-linear v-if="loading" indeterminate color="orange"></v-progress-linear>
        <v-card>
            <v-card-title dark>
                <h3 class="ma-2">Contribution Activity Reports Club Wise</h3>
                <v-spacer></v-spacer>
                <AutocompleteSearch @changeData="clubId = $event" :storeLink="'member/getRoleClubs'" :setectVale="clubId"
                    :itemText="'name'" :label="'Select Club'" />
                <v-spacer></v-spacer>
                <v-btn @click="loadTaskList()" :disabled="loading || !clubId">Download</v-btn>

            </v-card-title>

        </v-card>

    </div>
</template>

<script>
import { ActivityService } from "@/services/activity-service";
import { checkError } from "@/config/errors.js";
import AutocompleteSearch from "@/components/shared/AutocompleteSearch";
import { fileService } from "@/config/file-service.js";

export default {
    name: "ContributionClubWiseReport",
    components: { AutocompleteSearch },

    data: function () {
        return {
            loading: false,
            filterBtnTTip: false,
            list: [],
            clubId: null,
            role: localStorage.getItem("role"),
            errors: null,
            successMsg: "",
            snackbar: false,
        };
    },

    mounted() {
        this.$store.dispatch("auth/getProfile");

        if (this.role == 'CLUB_PRESIDENT' || this.role == 'CLUB_SECRETARY' || this.role == 'CLUB_TREASURER' || this.role == 'CLUB_ADMINISTRATOR') {
            this.clubId = localStorage.getItem("club_id");
        }
    },

    methods: {
        loadTaskList() {
            if (this.clubId) {
                this.loading = true;
                ActivityService.getActivityContributionClubReport(this.clubId, {
                    responseType: "blob",
                })
                    .then((response) => {
                        this.loading = false;
                        if (response.data) {
                            this.list = response.data;
                            this.loading = false;
                            let fileType = response.headers["content-type"];
                            let extension = "csv";
                            fileService.downloadFile(
                                response.data,
                                fileType,
                                extension,
                                "contribution-activity-" + this.clubId
                            );
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                        let data = error.response.data;
                        let errorOutput = checkError.errorFormatting(data);
                        this.errors = errorOutput;
                        this.list = [];
                    });
            }

        }


    },
};
</script>
